module.exports = __webpack_public_path__ + "img/thumbnail_Capybara_f_normal.045349fd.png";